import React from 'react';
import { Avatar as MuiAvatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  large: (props) => {
    if (props.size === 'large') {
      return {
        width: theme.spacing(15),
        height: theme.spacing(15),
      };
    }
    return {
      width: theme.spacing(10),
      height: theme.spacing(10),
    };
  },
}));

const Avatar = ({ src, variant, size }) => {
  const classes = useStyles({ size });
  return <MuiAvatar variant={variant} src={src} className={classes.large} />;
};

Avatar.defaultProps = {
  variant: 'square',
};

export default Avatar;
